module.exports = __webpack_public_path__ + "img/active-checked-icon.0cec6f29.svg";